import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import { Box, Flex, TextSpan } from 'app/components/design-system-components'
import { Select } from 'app/components/design-system-components/inputs/Select/Select'
import { FilterDateRange } from 'app/components/design-system-components/list-filters/FilterDateRange'
import { FilterDropdown } from 'app/components/design-system-components/list-filters/FilterDropdown'
import {
  dateRangeFiltersFields,
  getPeriodOptionValue,
  periodsOptions,
} from 'app/dashboard/team_activity/ActivityFilters/DateRangeFilter'
import { activityPeriods } from 'app/dashboard/team_activity/ActivityFilters/DateRangeFilter/constants'
import {
  buildRenderedFilterConfig,
  filtersIds,
} from 'app/dashboard/team_activity/ActivityFilters/filters.config'
import MultiTeamReportingDropdown from 'app/dashboard/team_activity/multi_team_reporting_dropdown/component'

export const ActivitiesFilters = ({
  filters,
  initialPeriod,
  updateFilter,
  teamId,
  managers,
  pods,
  includeManagersFilter,
  onPeriodChange,
  onFiltersInitialized,
  multiTeamOptions = {},
  hasMultiTeamFilter = true,
  includePodsFilter,
  isPodsDisabled = false,
  ...containerProps
}) => {
  // filters initialization (period initialization only required)
  const [periodInitiator, setPeriodInitiator] = useState(
    periodsOptions.find((opt) => opt.optionMeta.id === initialPeriod),
  )

  onFiltersInitialized?.()

  const {
    [filtersIds.dateRange]: dateRangeFilterConfig,
    [filtersIds.manager]: managerFilterConfig,
    [filtersIds.pods]: podsFilterConfig,
  } = buildRenderedFilterConfig(
    filters,
    updateFilter,
    includeManagersFilter,
    includePodsFilter,
  )

  useEffect(() => {
    onPeriodChange && onPeriodChange(periodInitiator)
    if (
      !periodInitiator ||
      periodInitiator.optionMeta.id === activityPeriods.custom
    ) {
      return
    }
    const range = getPeriodOptionValue(periodInitiator?.optionMeta.id)
    dateRangeFilterConfig.setFilterValues({
      [filtersIds.dateRange]: {
        ...{
          [dateRangeFiltersFields.start]: range.startDate,
          [dateRangeFiltersFields.end]: range.endDate,
        },
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodInitiator])

  const onDateRangeManualUpdate = (date) => {
    setPeriodInitiator(
      periodsOptions.find(
        (opt) => opt.optionMeta.id === activityPeriods.custom,
      ),
    )
  }

  return (
    <Flex flexWrap="wrap" alignItems="center" {...containerProps}>
      <Select
        options={periodsOptions}
        value={periodInitiator}
        changeHandler={(opt) => setPeriodInitiator(opt)}
        label="Select period"
        resultsLabel="PERIODS"
        width="205px"
        triggerWrapperComponentProps={{ height: '40px' }}
        mr={3}
        mb={3}
      />
      <Box mb={3} mr={3}>
        <FilterDateRange
          onChange={onDateRangeManualUpdate}
          filterConfig={dateRangeFilterConfig}
          dropDownWidth="175px"
        />
      </Box>
      {managerFilterConfig && (
        <Flex alignItems="center" mb={3}>
          <FilterDropdown
            filterConfig={managerFilterConfig}
            filterBodyProps={{ managers }}
            triggerCmpProps={{ height: '40px', mr: 3, sizeVariant: 'regular' }}
          />
        </Flex>
      )}

      {podsFilterConfig && (
        <Flex alignItems="center" mb={3}>
          <FilterDropdown
            filterConfig={podsFilterConfig}
            filterBodyProps={{ pods, disabled: isPodsDisabled }}
            triggerCmpProps={{ height: '40px', mr: 3, sizeVariant: 'regular' }}
          />
        </Flex>
      )}

      {hasMultiTeamFilter && (
        <Box mb={3}>
          <MultiTeamReportingDropdown
            teamId={teamId}
            multiTeamOptions={multiTeamOptions} // {singleSelectTeam: boolean}
            updateFilter={updateFilter}
            dropDownWidth="175px"
          />
        </Box>
      )}
    </Flex>
  )
}

ActivitiesFilters.propTypes = {
  filters: PropTypes.any,
  initialPeriod: PropTypes.string,
  updateFilter: PropTypes.func,
  teamId: PropTypes.string,
  managers: PropTypes.any,
  pods: PropTypes.any,
  includeManagersFilter: PropTypes.bool,
  onPeriodChange: PropTypes.func,
  onFiltersInitialized: PropTypes.any,
  children: PropTypes.element,
}
